import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import Routing from './Routing';
import reportWebVitals from './reportWebVitals';
import './index.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


const container = document.getElementById('root');
const root = createRoot(container);

root.render( 
  <Provider store={store}>
    <Routing />
  </Provider>
);

reportWebVitals();
